import React, { useEffect, useState } from "react";
import { Undo2 } from "lucide-react";

export const UndoBanner = ({ message, onUndo, onExpire, seconds = 10, testId = "undo-banner" }) => {
  const [left, setLeft] = useState(seconds);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setLeft(seconds);
    const t = setInterval(() => setLeft((l) => l - 1), 1000);
    return () => clearInterval(t);
  }, [seconds, message]);

  useEffect(() => {
    if (left <= 0) onExpire?.();
    // eslint-disable-next-line
  }, [left]);

  const undo = async () => {
    setBusy(true);
    try {
      await onUndo();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card mb-4 overflow-hidden" data-testid={testId} role="status">
      <div className="p-3 flex items-center gap-3 flex-wrap">
        <Undo2 size={16} className="text-[#C9A84C] shrink-0" />
        <span className="flex-1 text-sm" data-testid={`${testId}-message`}>{message}</span>
        <button
          type="button"
          className="btn-primary !py-1.5 !px-3 !text-xs inline-flex items-center gap-1"
          onClick={undo}
          disabled={busy}
          data-testid={`${testId}-button`}
        >
          <Undo2 size={12} /> {busy ? "Desfazendo..." : `Desfazer (${Math.max(left, 0)}s)`}
        </button>
      </div>
      <div className="h-[3px] bg-white/5">
        <div
          className="h-full bg-[#C9A84C]"
          style={{ width: `${(Math.max(left, 0) / seconds) * 100}%`, transition: "width 1s linear" }}
        />
      </div>
    </div>
  );
};
